// src/utils/error-sanitizer.js
export function sanitizeError(error) {
  // Lista de patrones que indican errores técnicos que no deben mostrarse
  const technicalErrorPatterns = [
    /PreparedStatementCallback/i,
    /SQLException/i,
    /JDBC/i,
    /MySQL/i,
    /MariaDB/i,
    /com\.linklabs/i,
    /org\.springframework/i,
    /java\./i,
    /INSERT INTO/i,
    /SELECT.*FROM/i,
    /UPDATE.*SET/i,
    /DELETE FROM/i,
    /Data truncation/i,
    /column.*too long/i,
  ];

  const errorMessage = error?.data?.message || error?.message || '';
  
  // Verificar si el error contiene información técnica sensible
  const isTechnicalError = technicalErrorPatterns.some(pattern => 
    pattern.test(errorMessage)
  );

  if (isTechnicalError) {
    return {
      ...error,
      data: {
        ...error.data,
        message: 'An error occurred while processing your request. Please try again or contact support.',
        originalError: process.env.NODE_ENV === 'development' ? errorMessage : undefined
      }
    };
  }

  return error;
}